import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as documentStateActions from "../../documents/actions/documentStatesActions";

class DocumentStateLegendChart extends React.Component {

  componentWillMount(){
    this.props.documentStateActions.getDocumentStates();
  }

  render() {
    const className = 'chart-key m-t-15 ' + this.props.className;

    return (
      <div className={className}>
        {this.props.documentStates.map((documentState, i) => {
          return(<span key={i}><span className="badge-state" style={{ backgroundColor: '#' + documentState.color }}> </span>{documentState.name}<br/></span>);
        })}
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    documentStates: state.documentStates.documentStates,
  }
};

const mapDispatchToProps = dispatch => ({
  documentStateActions: bindActionCreators(documentStateActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DocumentStateLegendChart)

DocumentStateLegendChart.propTypes = {
  className: PropTypes.string
};

DocumentStateLegendChart.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/DocumentStateLegendChart.js